import React, { useState } from "react";

export const TeamBadge = ({ team, size = 44 }) => {
  const [err, setErr] = useState(false);
  const color = team?.color || "#D4AF37";
  const short = team?.short || "?";
  const hasCrest = team?.crest && !err;

  // Tennis players carry a `flag` key (URL or empty). Render a rectangular flag,
  // or a neutral grey placeholder when the country is unknown — never initials.
  if (team && Object.prototype.hasOwnProperty.call(team, "flag")) {
    const w = Math.round(size * 1.35);
    const h = Math.round(size * 0.9);
    if (team.flag && !err) {
      return (
        <div
          className="shrink-0 overflow-hidden rounded-md"
          style={{ width: w, height: h, border: "1px solid rgba(255,255,255,0.18)", boxShadow: "0 3px 10px rgba(0,0,0,0.35)" }}
        >
          <img
            src={team.flag}
            alt={short}
            onError={() => setErr(true)}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        </div>
      );
    }
    return (
      <div
        className="shrink-0 rounded-md"
        style={{ width: w, height: h, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)" }}
      />
    );
  }

  if (hasCrest) {
    return (
      <div
        className="shrink-0 flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        <img
          src={team.crest}
          alt={short}
          onError={() => setErr(true)}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-center rounded-full font-numeral font-bold shrink-0"
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle at 30% 25%, ${color}, ${color}99)`,
        border: "1px solid rgba(255,255,255,0.14)",
        boxShadow: `0 4px 14px ${color}44`,
        fontSize: size * 0.32,
      }}
    >
      <span className="text-white drop-shadow">{short}</span>
    </div>
  );
};
